/**
 * ProjectsToolbar — search input + filter chips + sort button.
 * canonical: S2 lines 1349–1382 (.hub-toolbar, .hub-search, .hub-chips)
 *
 * No Tailwind — all styles from tokens.css.
 */

export type FilterChip = 'all' | 'active' | 'pay-due' | 'lien-risk' | 'on-hold'

interface Props {
  search:        string
  activeFilter:  FilterChip
  totalCount:    number
  onSearch:      (v: string) => void
  onFilter:      (f: FilterChip) => void
}

const CHIPS: { key: FilterChip; label: string }[] = [
  { key: 'all',       label: 'All'       },
  { key: 'active',    label: 'Active'    },
  { key: 'pay-due',   label: 'Pay due'   },
  { key: 'lien-risk', label: 'Lien risk' },
  { key: 'on-hold',   label: 'On hold'   },
]

export default function ProjectsToolbar({
  search, activeFilter, totalCount, onSearch, onFilter,
}: Props) {
  return (
    <div className="hub-toolbar">
      {/* canonical: .hub-search */}
      <input
        className="hub-search"
        placeholder="Search project, owner, address…"
        value={search}
        onChange={e => onSearch(e.target.value)}
      />

      {/* canonical: .hub-chips */}
      <div className="hub-chips">
        {CHIPS.map(({ key, label }) => (
          <button
            key={key}
            className={`hub-chip${activeFilter === key ? ' on' : ''}`}
            onClick={() => onFilter(key)}
          >
            {label}{key === 'all' ? ` · ${totalCount}` : ''}
          </button>
        ))}
      </div>

      {/* canonical: sort button */}
      <button className="btn b-ol btn-sm">Sort: outstanding ↓</button>
    </div>
  )
}
